module.exports = __webpack_public_path__ + "static/media/magic-wand.c3c2093d.svg";